export const state = {
  modalViewProduct: false,
  products: [],
  product: {},
  markedProducts: []
};

export default {};
